import { NotificationSection } from './notification-section';
import { ResponsiveSectionTitle } from './responsive-section-title';
import { useTranslation } from 'react-i18next';
import type { NotificationToggle } from './notification-toggle.types';
import { ToggleRows } from './toggle-rows';

export const OptionalNotificationSection = ({
  helpKey,
  isLargeUI,
  titleKey,
  toggles,
  visible,
}: {
  helpKey: string;
  isLargeUI: boolean;
  titleKey: string;
  toggles: NotificationToggle[];
  visible: boolean;
}) => {
  const { t } = useTranslation('notifications-setting');
  if (!visible) return null;

  return (
    <NotificationSection
      separated
      title={<ResponsiveSectionTitle {...{ isLargeUI }}>{t(titleKey)}</ResponsiveSectionTitle>}
      description={t(helpKey)}
    >
      <ToggleRows {...{ toggles }} />
    </NotificationSection>
  );
};
